import * as React from 'react';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import ErrorSnackbar from '../shared/ErrorSnackbar/ErrorSnackbar';
import * as styles from './Layout.css';

interface LayoutProps {
  children: Array<string | JSX.Element> | JSX.Element | string;
  fullWidth?: boolean;
  backgroundColor?: string;
}

const Layout = ({ children, fullWidth, backgroundColor }: LayoutProps) => {
  const [showTab, setShowTab] = React.useState(false);

  return (
    <div>
      <Header />
      <div style={backgroundColor ? { backgroundColor } : {}}>
        <div className={styles.children} style={!fullWidth ? { margin: '0 5%' } : {}}>
          {children}
        </div>
      </div>
      <Footer />
      <ErrorSnackbar />
    </div>
  );
};

export default Layout;
